import React from 'react';
import type { CandidateWorkFeedItem } from '@axiom/validation';
import {
  backgroundColorNames,
  Badge,
  Gutter,
  Layout,
  CondensedMedium,
  LayoutItem,
  Accolade,
  Icon,
  DateUtil,
} from '@axiom/ui';
import { WorkFeedConst } from '@axiom/const';

import { WorkFeedUtil } from '../../utils/WorkFeedUtil';

const { Phases } = WorkFeedConst;

const badgeColorMap = {
  [Phases.New]: backgroundColorNames.forestGreen,
  [Phases.Submitted]: backgroundColorNames.lightOrange,
  [Phases.Interviewing]: backgroundColorNames.lightOrange,
  [Phases.Closed]: backgroundColorNames.gray,
} as const;

export const WorkFeedCardBadges = ({
  workFeedItem,
  name = 'WORK_FEED_CARD_BADGES',
}: {
  workFeedItem: CandidateWorkFeedItem;
  name?: string;
}) => {
  const displayBadges =
    !workFeedItem.rejectionLossCode &&
    !WorkFeedUtil.isUnavailableToCandidate(workFeedItem) &&
    !workFeedItem.opportunity.isExcludedFromFeed;
  const displayAcceptingSinceEOI =
    workFeedItem.opportunity.madeAvailableToFeedNotificationAt;
  return displayAcceptingSinceEOI || displayBadges ? (
    <Layout name={name} position="middle space-between" horizontalGutter="8px">
      <LayoutItem hug>
        <Gutter bottom="16px">
          <Layout horizontalGutter="8px" verticalGutter="8px" wrap>
            {displayBadges ? (
              <Badge
                name="OPPORTUNITY_STAGE"
                background={badgeColorMap[workFeedItem.phase]}
              >
                {WorkFeedUtil.formatPhaseForDisplay(workFeedItem.phase)}
              </Badge>
            ) : null}
            {displayAcceptingSinceEOI ? (
              <CondensedMedium
                as="span"
                name="OPPORTUNITY_TIME_SINCE_ACCEPTING_INTEREST"
              >
                Accepting interest as of{' '}
                {DateUtil.displayRelativeTime(
                  workFeedItem.opportunity.madeAvailableToFeedNotificationAt
                )}
              </CondensedMedium>
            ) : null}
          </Layout>
        </Gutter>
      </LayoutItem>
      {workFeedItem.opportunity.selfService ? (
        <LayoutItem>
          <Accolade
            color="purple"
            label="Self-service"
            name="SELF_SERVICE_ACCOLADE"
          >
            <Icon name="star-filled" />
          </Accolade>
          <Gutter bottom="16px" />
        </LayoutItem>
      ) : null}
    </Layout>
  ) : null;
};
